import {TurnState} from '@colonist/game-states'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {TimeUtils} from '@colonist/utils'
import {ClientUserState} from '../../ClientUserState'

export class UIGameBeginnerHintsController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.GameStateUpdated: this.gameStateUpdated(); break
            default: break
        }
    }

    private gameStateUpdated() {
        if(!this.shouldRequestBeginnerHint()) return

        const requestHintTime = this.uiGameManager.gameController.currentState.allocatedTime
        const timerEndTime = Date.now() / TimeUtils.MILLISECONDS + TimeUtils.secondsLeftForCurrentState(this.uiGameManager.gameController.timeLeftInCurrentState)
        const remainingTime = Math.round(timerEndTime - Date.now() / TimeUtils.MILLISECONDS)
        if(remainingTime == requestHintTime) this.uiGameManager.socketGameSend.requestHintForBeginner(false)
    }

    private shouldRequestBeginnerHint(): boolean {
        if(!this.uiGameManager.gameController.isMyTurn) return false
        if(this.uiGameManager.gameController.currentState.turnState != TurnState.InitialPlacement) return true
        if(ClientUserState.userState?.hasZeroCompletedGames()) return true
        return false
    }
}
